exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#reports_edit_page .search-accounts {\n  width: 20vw;\n}\n#reports_edit_page .data-connection-accounts {\n  font-size: 1.2rem;\n}\n#reports_edit_page .data-connection-accounts td:first-child {\n  font-weight: 500;\n}\n#reports_edit_page .data-connection-accounts img {\n  width: 3.2rem;\n}\n#reports_edit_page .pretty.p-default input:checked ~ .state label::after {\n  background-color: #36a8cd !important;\n}\n#reports_edit_page .pretty.p-switch input:checked ~ .state label::after {\n  background-color: #36a8cd !important;\n}", ""]);

// exports
